<template>
  <div class="vx-col w-full mb-base m-auto">
    <vx-card :title="'Manage leaves'">
      <div class="text-right add-leave" v-if="!leaveAddEdit">
        <vs-button
          class="mt-4 mb-5 m-auto"
          color="#0057FF"
          @click.prevent="leaveAddEdit = true"
        >Add Leave</vs-button>
      </div>
      <form class="w-full" v-if="leaveAddEdit" autocomplete="off">
        <div class="vx-row mb-2">
          <h4 class="ml-5 mb-5">Add Leave</h4>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col md:w-1/4 form-group w-full">
            <vs-select
              class="w-full"
              v-validate="'required'"
              label="Leave Type"
              name="type"
              v-model="type"
              autocomplete
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.value"
                v-for="(item,index) in leavetypes"
              />
            </vs-select>
            <span class="text-danger text-sm">{{ errors.first('type') }}</span>
          </div>
        </div>
        <div class="vx-row w-full mb-2 mt-2">
          <div class="vx-col form-group md:w-1/4 w-full pr-1">
            <label for class="vs-input--label">Description</label>
            <vs-textarea v-model="note" v-validate="'max:200'" name="note" />
            <span class="text-danger text-sm">{{ errors.first("note") }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col form-group w-full">
            <h4>Start Day Details</h4>
            <div class="vx-row">
              <div class="vx-col md:w-1/4 form-group w-full">
                <label for class="vs-input--label">Start Date</label>
                <flat-pickr
                  :config="configFromdateTimePicker"
                  @on-change="onFromChange"
                  class="vs-inputx vs-input--input normal time"
                  label="Start Date"
                  v-validate="'required'"
                  name="start_date"
                  v-model="start_date"
                  autocomplete="off"
                />
                <span class="text-danger text-sm">{{ errors.first('start_date') }}</span>
              </div>
              <div class="vx-col md:w-1/4 form-group w-full">
                <label for class="vs-input--label">Start Day</label>
                <vs-radio
                  v-model="start_day_option"
                  vs-name="start_day_option"
                  name="start_day_option"
                  v-validate="'required'"
                  vs-value="F"
                >Full Day</vs-radio>
                <vs-radio
                  v-model="start_day_option"
                  vs-name="start_day_option"
                  v-validate="'required'"
                  name="start_day_option"
                  vs-value="H"
                >Partial Day</vs-radio>

                <span class="text-danger text-sm">{{ errors.first('start_day_option') }}</span>
              </div>
              <div class="vx-col md:w-1/4 form-group w-full" v-if="start_day_option == 'H'">
                <label for class="vs-input--label">Start Time</label>
                <flat-pickr
                  :config="configdateTimePicker"
                  class="vs-inputx vs-input--input normal time"
                  v-validate="(start_day_option == 'H')?'required':''"
                  v-model="start_time"
                  autocomplete="off"
                  name="start_time"
                  @input="calculateDays"
                />
                <span class="text-danger text-sm">{{ errors.first('start_time') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col form-group w-full">
            <h4>End Day Details</h4>
            <div class="vx-row">
              <div class="vx-col md:w-1/4 form-group w-full">
                <label for class="vs-input--label">End Date</label>
                <flat-pickr
                  :config="configTodateTimePicker"
                  class="vs-inputx vs-input--input normal time"
                  label="End Date"
                  v-validate="'required'"
                  name="end_date"
                  v-model="end_date"
                  autocomplete="off"
                  @input="calculateDays"
                />
                <span class="text-danger text-sm">{{ errors.first('end_date') }}</span>
              </div>
              <div class="vx-col md:w-1/4 form-group w-full">
                <label for class="vs-input--label">End Day</label>
                <vs-radio
                  v-model="end_day_option"
                  vs-name="end_day_option"
                  vs-value="Full"
                  name="end_day_option"
                  v-validate="'required'"
                  :disabled="disableOption"
                >Full Day</vs-radio>
                <vs-radio
                  v-model="end_day_option"
                  vs-name="end_day_option"
                  vs-value="Half"
                  name="end_day_option"
                  v-validate="'required'"
                  :disabled="disableOption"
                >Partial Day</vs-radio>

                <span class="text-danger text-sm">{{ errors.first('end_day_option') }}</span>
              </div>
              <div class="vx-col md:w-1/4 form-group w-full" v-if="end_day_option == 'Half'">
                <label for class="vs-input--label">End Time</label>
                <flat-pickr
                  :config="configdateTimePicker"
                  class="vs-inputx vs-input--input normal time"
                  v-validate="'required'"
                  v-model="end_time"
                  autocomplete="off"
                  name="end_time"
                  @input="calculateDays"
                />
                <span class="text-danger text-sm">{{ errors.first('end_time') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row mb-2" v-if="start_date && end_date">
          <div class="vx-col w-1/5">
            <vs-input name="days" v-model="totalDays" class="w-full" disabled />
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-button
              class="mt-1 m-auto"
              color="#0057FF"
              @click.prevent="addLeave()"
              :disabled="button_loading"
              id="leave-addupdate"
            >Apply</vs-button>
            <vs-button class="mt-1 ml-4 m-auto" color="warning" @click.prevent="cancelAdd()">Cancel</vs-button>
          </div>
        </div>
      </form>
      <vs-tabs v-if="!leaveAddEdit">
        <vs-tab label="Pending">
          <div class="tab-text">
            <div class="mt-10 mb-5">
              <vs-table :data="pending" pagination max-items="5" class="mt-10 mb-5">
                <template slot="thead">
                  <vs-th>Leave Type</vs-th>
                  <vs-th>Note</vs-th>
                  <vs-th>Applied On</vs-th>
                  <vs-th>Start Leave</vs-th>
                  <vs-th>End Leave</vs-th>
                  <vs-th>Status</vs-th>
                  <vs-th>Total Days</vs-th>
                  <vs-th>Action</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                    <vs-td>{{ tr.type.value | capitalize }}</vs-td>
                    <vs-td>
                      <vs-button
                        v-if="tr.note"
                        color="success"
                        type="flat"
                        icon-pack="feather"
                        icon="icon-eye"
                        class="mr-2 mb-2 edit-user float-left"
                        size="small"
                        title="View Note"
                        @click.stop="viewNote(tr.note)"
                      ></vs-button>
                      <span v-else>-</span>
                    </vs-td>
                    <vs-td>{{ tr.createdAt | moment('timezone',$store.state.uInfo.timeZone, 'DD/MM/YY h:mm A') }}</vs-td>
                    <vs-td>{{ tr.start_time | moment('timezone',$store.state.uInfo.timeZone, 'DD/MM/YY h:mm A') }}</vs-td>
                    <vs-td>{{ tr.end_time | moment('timezone',$store.state.uInfo.timeZone, 'DD/MM/YY h:mm A') }}</vs-td>
                    <vs-td>{{ (tr.status == 'P')?"Pending":"" }}</vs-td>
                    <vs-td>           <span v-if="tr.start_day_option === 'F' && tr.end_day_option === 'F' && tr.totalDays">{{ tr.totalDays > 1 ? tr.totalDays+" days" : tr.totalDays+" day" }}</span>
                       <span v-if="(tr.start_day_option === 'F' && tr.end_day_option === 'H') || (tr.start_day_option === 'H' && tr.end_day_option === 'F')">{{ tr.totalDays }} {{ tr.totalDays > 1 ?" days " :" day "}}
                       {{  convertToTime(tr.totalMinutes) }}
                       </span>
                      <span v-if="tr.start_day_option === 'H' && tr.end_day_option === 'H' && tr.totalDays == 0">{{ convertToTime(tr.totalMinutes) }}</span>
                      <span v-if="tr.start_day_option === 'H' && tr.end_day_option === 'H' && tr.totalDays != 0">{{ tr.totalDays}}{{ tr.totalDays > 1 ?" days " :" day "  }}{{  convertToTime(tr.totalMinutes) }}</span>
                      </vs-td>
                    <vs-td>
                      <vs-button
                        color="danger"
                        type="filled"
                        class="mr-2 mb-2 edit-user float-left"
                        size="small"
                        title="Cancel Leave"
                        @click.stop="cancelConfirmation(tr.id)"
                      >Cancel</vs-button>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Approved">
          <div class="tab-text">
            <div class="mt-10 mb-5">
              <vs-table :data="approved" pagination max-items="5" class="mt-10 mb-5">
                <template slot="thead">
                  <vs-th>Leave Type</vs-th>
                  <vs-th>Note</vs-th>
                  <vs-th>Applied On</vs-th>
                  <vs-th>Start Leave</vs-th>
                  <vs-th>End Leave</vs-th>
                  <vs-th>Status</vs-th>
                  <vs-th>Total Days</vs-th>
                  <vs-th>Action</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ tr.type.value | capitalize }}</vs-td>
                    <vs-td>
                      <vs-button
                        v-if="tr.note"
                        color="success"
                        type="flat"
                        icon-pack="feather"
                        icon="icon-eye"
                        class="mr-2 mb-2 edit-user float-left"
                        size="small"
                        title="View Note"
                        @click.stop="viewNote(tr.note)"
                      ></vs-button>
                      <span v-else>-</span>
                    </vs-td>
                    <vs-td>{{ tr.createdAt | moment('timezone',$store.state.uInfo.timeZone, 'DD/MM/YY h:mm A') }}</vs-td>
                    <vs-td>{{ tr.start_time | moment('timezone',$store.state.uInfo.timeZone, 'DD/MM/YY h:mm A') }}</vs-td>
                    <vs-td>{{ tr.end_time | moment('timezone',$store.state.uInfo.timeZone, 'DD/MM/YY h:mm A') }}</vs-td>
                    <vs-td>{{ (tr.status == 'A')?"Approved":"" }}</vs-td>
                    <vs-td>           <span v-if="tr.start_day_option === 'F' && tr.end_day_option === 'F' && tr.totalDays">{{ tr.totalDays > 1 ? tr.totalDays+" days" : tr.totalDays+" day" }}</span>
                       <span v-if="(tr.start_day_option === 'F' && tr.end_day_option === 'H') || (tr.start_day_option === 'H' && tr.end_day_option === 'F')">{{ tr.totalDays }} {{ tr.totalDays > 1 ?" days " :" day "}}
                       {{  convertToTime(tr.totalMinutes) }}
                       </span>
                      <span v-if="tr.start_day_option === 'H' && tr.end_day_option === 'H' && tr.totalDays == 0">{{ convertToTime(tr.totalMinutes) }}</span>
                      <span v-if="tr.start_day_option === 'H' && tr.end_day_option === 'H' && tr.totalDays != 0">{{ tr.totalDays}}{{ tr.totalDays > 1 ?" days " :" day "  }}{{  convertToTime(tr.totalMinutes) }}</span>
                      </vs-td>
                    <vs-td>
                      <vs-button
                        color="danger"
                        type="filled"
                        class="mr-2 mb-2 edit-user float-left"
                        size="small"
                        title="Cancel Leave"
                        @click.stop="cancelConfirmation(tr.id)"
                      >Cancel</vs-button>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Declined">
          <div class="tab-text">
            <div class="mt-10 mb-5">
              <vs-table :data="declined" pagination max-items="5" class="mt-10 mb-5">
                <template slot="thead">
                  <vs-th>Leave Type</vs-th>
                  <vs-th>Note</vs-th>
                  <vs-th>Applied On</vs-th>
                  <vs-th>Start Leave</vs-th>
                  <vs-th>End Leave</vs-th>
                  <vs-th>Status</vs-th>
                  <vs-th>Comment</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ tr.type.value | capitalize }}</vs-td>
                    <vs-td>
                      <vs-button
                        v-if="tr.note"
                        color="success"
                        type="flat"
                        icon-pack="feather"
                        icon="icon-eye"
                        class="mr-2 mb-2 edit-user float-left"
                        size="small"
                        title="View Note"
                        @click.stop="viewNote(tr.note)"
                      ></vs-button>
                      <span v-else>-</span>
                    </vs-td>
                    <vs-td>{{ tr.createdAt | moment('timezone',$store.state.uInfo.timeZone, 'DD/MM/YY h:mm A') }}</vs-td>
                    <vs-td>{{ tr.start_time | moment('timezone',$store.state.uInfo.timeZone, 'DD/MM/YY h:mm A') }}</vs-td>
                    <vs-td>{{ tr.end_time | moment('timezone',$store.state.uInfo.timeZone, 'DD/MM/YY h:mm A') }}</vs-td>
                    <vs-td>{{ (tr.status == 'C')?"Canceled":(tr.status == 'D')?"Declined":"" }}</vs-td>
                    <vs-td>{{ (tr.status == 'C')?"Self Declined":(tr.status == 'D')?(tr.decline_note?"Declined By "+tr.declined_by.firstname+' '+tr.declined_by.lastname+' for '+tr.decline_note:"Declined By "+tr.declined_by.firstname+' '+tr.declined_by.lastname):"" }}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
       <div id="simple-calendar-app">
        <div class="vx-card no-scroll-content p-4">
          <calendar-view
            ref="calendar"
            :displayPeriodUom="calendarView"
            :show-date="showDate"
            :events="events"
            :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
            eventBorderHeight="0px"
            eventContentHeight="1.5rem"
            @click-event="openEditEvent"
            class="theme-default"
          >
            <div slot="header" class="mb-4 header-month">
              <div class="flex justify-center">
                <!-- Month Name -->

                <!-- Current Month -->
                <div class="mr-4 self-center">
                  <div class="flex items-center">
                    <feather-icon
                      :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                      @click="updateMonth(-1)"
                      svgClasses="w-5 h-5 m-1"
                      class="cursor-pointer bg-primary text-white rounded-full"
                    />

                    <span class="mx-3 text-xl font-medium whitespace-no-wrap">
                      {{ showDate | month }}
                    </span>

                    <feather-icon
                      :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                      @click="updateMonth(1)"
                      svgClasses="w-5 h-5 m-1"
                      class="cursor-pointer bg-primary text-white rounded-full"
                    />
                  </div>
                </div>

                <div class="ml-4">
                  <template v-for="(view, index) in calendarViewTypes">
                    <vs-button
                      v-if="calendarView === view.val"
                      :key="String(view.val) + 'filled'"
                      type="filled"
                      class="p-3 md:px-8 md:py-3"
                      :class="{
                        'border-l-0 rounded-l-none': index,
                        'rounded-r-none':
                          calendarViewTypes.length !== index + 1,
                      }"
                      @click="calendarView = view.val"
                      >{{ view.label }}</vs-button
                    >
                    <vs-button
                      v-else
                      :key="String(view.val) + 'border'"
                      type="border"
                      class="p-3 md:px-8 md:py-3"
                      :class="{
                        'border-l-0 rounded-l-none': index,
                        'rounded-r-none':
                          calendarViewTypes.length !== index + 1,
                      }"
                      @click="calendarView = view.val"
                      >{{ view.label }}</vs-button
                    >
                  </template>
                </div>
              </div>

              <div class="vx-row sm:flex hidden mt-4">
                <div class="vx-col w-full flex">
                  <!-- Labels -->
                  <div class="flex flex-wrap sm:justify-start justify-center">
                    <div
                      v-for="(label, index) in eventLabels"
                      :key="index"
                      class="flex items-center mr-4 mb-2"
                    >
                      <div
                        class="h-3 w-3 inline-block rounded-full mr-2"
                        :class="'bg-' + label.color"
                      ></div>
                      <span>{{ label.text }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </calendar-view>
        </div>
      </div>
    </vx-card>
    <vs-popup
      class="holamundo note-popup"
      title="Note"
      :active.sync="ViewNote"
      :button-close-hidden="false"
    >
      <div class="vx-col vs-lg-12 float-left form-group mb-2 w-full">
        <h5>{{note}}</h5>
      </div>
    </vs-popup>
    <vs-popup class="holamundo" title="Confirm" :active.sync="cancelL" :button-close-hidden="true">
      <div class="vx-col vs-lg-12 float-left form-group mb-2 w-full">
        <h5>Are you sure you want to cancel this leave?</h5>
      </div>
      <div class="vx-col vs-lg-12 mt-2 float-left form-group mb-2 w-full">
        <vs-button
          color="success"
          type="filled"
          class="mr-2 edit-user float-left"
          @click.stop="cancelLeave()"
        >Cancel Leave</vs-button>
        <vs-button
          color="warning"
          type="filled"
          class="mr-2 edit-user float-left"
          @click.stop="cancelL = false, cancel_id = null"
        >Cancel</vs-button>
      </div>
    </vs-popup>
       <vs-popup
      class="holamundo"
      title="Leave Details"
      :active.sync="activePromptEditEvent"
      :button-close-hidden="true"
    >
      <div class="overflow-auto mb-5">
        <table v-if="viewLeaveData">
          <tr>
            <th>Name</th>
            <td>
              <div
                class="relative inline-flex float-left"
                v-if="
                  viewLeaveData.profile_image ||
                  (viewLeaveData.firstname && viewLeaveData.lastname)
                "
              >
                <vs-avatar
                  class="m-0"
                  :src="viewLeaveData.profile_image"
                  size="50px"
                  v-if="viewLeaveData.profile_image"
                />
                <vs-avatar
                  color="primary"
                  class="m-0 name-avatar"
                  :text="
                    usernameList(
                      viewLeaveData.firstname,
                      viewLeaveData.lastname
                    )
                  "
                  size="50px"
                  v-else
                />
                <div class="ml-2 mt-3">
                  <b>
                    {{ viewLeaveData.firstname | capitalize }}
                    {{ viewLeaveData.lastname | capitalize }}
                  </b>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th>Leave Type</th>
            <td>{{ viewLeaveData.leaveType }}</td>
          </tr>

          <tr>
            <th>Start</th>
            <td>
              {{
                viewLeaveData.leaveStartTime ? viewLeaveData.leaveStartTime : ""
              }}
            </td>
          </tr>

          <tr>
            <th>End</th>
            <td>
              {{ viewLeaveData.leaveEndTime ? viewLeaveData.leaveEndTime : "" }}
            </td>
          </tr>
          <tr>
            <th>Note</th>
            <td>{{ viewLeaveData.note }}</td>
          </tr>
          <tr>
            <th>Status</th>
            <td>
              <span v-if="viewLeaveData.leaveStatus === 'P'">Pending</span>
              <span v-else-if="viewLeaveData.leaveStatus === 'A'"
                >Approved</span
              >
              <span v-else-if="viewLeaveData.leaveStatus === 'D'"
                >Declined</span
              >
              <span v-else-if="viewLeaveData.leaveStatus === 'C'">Cancel</span>
              <span v-else></span>
            </td>
          </tr>
        </table>
      </div>
      <vs-button
        color="warning"
        type="filled"
        class="mr-2 edit-user float-right"
        @click.stop="(viewLeaveData = {}), (activePromptEditEvent = false)"
        >Cancel</vs-button
      >
    </vs-popup>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import moment from "moment";
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar";
require("vue-simple-calendar/static/css/default.css");
const dict = {
  custom: {
    type: {
      required: "Please select leave type"
    },
    note: {
      required: "Please enter description",
      max: "Description should not be greater than 200 characters"
    },
    start_date: {
      required: "Please select start date"
    },
    start_time: {
      required: "Please select start time"
    },
    start_day_option: {
      required: "Please select start day"
    },
    end_date: {
      required: "Please select end date"
    },
    end_time: {
      required: "Please select end time"
    },
    end_day_option: {
      required: "Please select end day"
    }
  }
};
Validator.localize("en", dict);
export default {
  data() {
    return {
      holidayList:null,
      officeStartTime:null,
      officeEndTime:null,
      workingDaysArr:[],
      workingDays:0,
      disableOption: false,
      cancelL: false,
      cancel_id: null,
      leaves: [],
      pending: [],
      approved: [],
      ViewNote: false,
      note_view: null,
      declined: [],
      leaveAddEdit: false,
      leavetypes: [],
      title: "",
      type: null,
      start_day_option: "F",
      end_day_option: "Full",
      start_time: null,
      start_date: null,
      end_time: null,
      end_date: null,
      note: "",
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        dateFormat: "G:i K"
      },
      configFromdateTimePicker: {
        minDate: new Date(),
        maxDate: null,
        dateFormat: "d-m-Y"
      },
      configTodateTimePicker: {
        minDate: new Date(),
        dateFormat: "d-m-Y"
      },
      totalDays: 0,
      totalDaystopass:0,
      totalMinutespass:0,
       calendarView: "month",
          calendarViewTypes: [
        {
          label: "Month",
          val: "month",
        },
      ],
       showDate: new Date(),
       events:[],
        leavesCalendarData:[],
      eventLabels: [
        {
          text: "Approved",
          value: "approved",
          color: "success",
        },
        {
          text: "Pending",
          value: "pending",
          color: "warning",
        },
        {
          text: "Declined/Cancel",
          value: "declined",
          color: "danger",
        },
      ],
      viewLeaveData: {},
        activePromptAddEvent: false,
      activePromptEditEvent: false,
    };
  },
   components: {
    CalendarView,
    CalendarViewHeader,
  },
  created() {},
  mounted() {
    this.getLeaveType();
    this.getLeaveData();
    this.getDateTimeData();
    this.getCalendarData();
  },
  filters: {
    readMore(str) {
      if (!str) return "";
      return str.substr(0, 20) + " ... ";
    }
  },
  computed: {
    simpleCalendarEvents() {
      return this.$store.state.calendar.events;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },

  },
  watch: {
    start_day_option(val){
      if(val){
        this.start_time = null;
        this.calculateDays();
      }
    },
    end_day_option(val){
      if(val){
        this.end_time = null;
        this.calculateDays();
      }
    }
  },

  methods: {
     onFromChange(selectedDates, dateStr, instance) {
      this.$set(this.configTodateTimePicker, "minDate", dateStr);
      this.calculateDays();
    },
     getDateTimeData() {
      this.$vs.loading({ color: "primary" });

      let url = "oinfo/getInfo";
      this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;
          let startDay = data.week_start_day;
          let endDay = data.week_end_day;
          let days = [{day:1,name:'Mo'},{day:2,name:'Tu'},{day:3,name:'We'},{day:4,name:'Th'},{day:5,name:'Fr'},{day:6,name:'Sa'},{day:7,name:'Su'}];
          let start = days.find( ({ name }) => name === startDay );
          let end = days.find( ({ name }) => name === endDay );
          let workingDays = (end.day - start.day)+1;
          this.workingDays = workingDays;
          let daysWorking = [{day:0,name:'Su',fullname:"Sunday"},{day:1,name:'Mo',fullname:"Monday"},{day:2,name:'Tu',fullname:"Tuesday"},{day:3,name:'We',fullname:"Wednesday"},{day:4,name:'Th',fullname:'Thursday'},{day:5,name:'Fr',fullname:'Friday'},{day:6,name:'Sa',fullname:"Saturday"}];
          let startworkingday = daysWorking.find( ({ name }) => name === startDay );
          let endworkingday = daysWorking.find( ({ name }) => name === endDay );
          let startArr = [];
          let endArr = [];
         for (let index = 0; index < daysWorking.length; index++) {
            if(startworkingday.day  > endworkingday.day) {
                if(index >= startworkingday.day){
                 startArr.push(daysWorking[index].fullname);
                }
                if(index <= endworkingday.day){
                  endArr.push(daysWorking[index].fullname);
                }
              }
            else {
               if(startworkingday.day <=index && endworkingday.day >=index){
                startArr.push(daysWorking[index].fullname);
              } 
            }
          }
          this.workingDaysArr = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
          //this.workingDaysArr =  startArr.concat(endArr);
          this.officeStartTime = data.working_time_from;
          this.officeEndTime = data.working_time_to;
          this.holidayList = data.holidays;
        })
        .catch(e => {
          this.showError(e);
        });
    },
    getDaysBetweenDates(startDate, endDate) {
        var now = moment(startDate).clone(), dates = [];
         while (now.isSameOrBefore(moment(endDate))) {
            dates.push(now.format('DD/MM/YYYY'));
            now.add(1, 'days');
        }
        return dates;
    },
    convertToTime(totalMinutes) {
      if (totalMinutes) {
        const addZero = d => (d > 9 ? d.toString() : "0" + d.toString());
        let hours = addZero(Math.floor(totalMinutes / 60));
        let minutes = addZero(totalMinutes % 60);
        let str = hours != "01"?" hrs ":" hr ";
        return hours + str + minutes+" min";
      } else {
        return "00:00";
      }
    },
    calculateDays() {
      if (this.start_date && this.end_date) {
        var s = this.start_date.split("-");
        var e = this.end_date.split("-");

        let startDate = new Date(`${s[1]}-${s[0]}-${s[2]}`).getTime();
        var endDate = new Date(`${e[1]}-${e[0]}-${e[2]}`).getTime();
       
        let totalLeaveDays = 0;
          const stDt = moment(this.start_date,'DD-MM-YYYY').format('YYYY-MM-DD');
          const endDt = moment(this.end_date,'DD-MM-YYYY').format('YYYY-MM-DD');

          var dateList = this.getDaysBetweenDates(stDt, endDt);
          dateList.forEach(element => {
              if(this.workingDaysArr.includes(moment(element,'DD/MM/YYYY').format('dddd'))){
                if(!this.holidayList.find( ({ date }) => moment(date).format('DD/MM/YYYY') === element)){
                  totalLeaveDays++;
                }
              }
          });
          if(this.start_day_option == 'H' && this.end_day_option == 'Half' && startDate != endDate && this.start_time && this.end_time){
              totalLeaveDays = totalLeaveDays -2;
              let officeEnd = this.officeEndTime;
              let startTime = this.start_time;
             
              let newSt = moment(this.start_date+" "+startTime,"DD/MM/YYYY HH:mm A").valueOf();
              let newos = moment(this.start_date+" "+officeEnd,"DD/MM/YYYY HH:mm A").valueOf();
              let ofms = newos - newSt;
              let officestart = this.officeStartTime;
              let endTime = this.end_time;
              let newoe = moment(this.start_date+" "+officestart,"DD/MM/YYYY HH:mm A").valueOf();
              let newEnd = moment(this.start_date+" "+endTime,"DD/MM/YYYY HH:mm A").valueOf();
              let ofme = newEnd - newoe;

              let totTime = this.convertToTime((ofms+ofme)/(1000*60));
              this.totalDaystopass = totalLeaveDays;
               let wordDay = totalLeaveDays >1?" Days ":" Day ";
               totalLeaveDays = (totalLeaveDays != 0)?totalLeaveDays+wordDay+totTime:totTime;
              this.totalMinutespass = (ofms+ofme)/(1000*60);
          } else if(this.start_day_option == 'H' && this.end_day_option == 'Half' && startDate == endDate && this.start_time && this.end_time){
            let startTime = this.start_time;
            let newSt = moment(this.start_date+" "+startTime,"DD/MM/YYYY HH:mm A").valueOf();
            let endTime = this.end_time;
            let newEnd = moment(this.end_date+" "+endTime,"DD/MM/YYYY HH:mm A").valueOf();
            let ofme = newEnd - newSt;
            let totTime = this.convertToTime((ofme)/(1000*60));
            this.totalDaystopass = 0;
            this.totalMinutespass = (ofme)/(1000*60);
            totalLeaveDays = totTime;
          } else if(this.start_day_option == 'H' && this.start_time){
              totalLeaveDays = totalLeaveDays -1;
              let officeEnd = this.officeEndTime;
              let startTime = this.start_time;
              let newSt = moment(this.start_date+" "+startTime,"DD/MM/YYYY HH:mm A").valueOf();
              let newos = moment(this.start_date+" "+officeEnd,"DD/MM/YYYY HH:mm A").valueOf();
              let ofms = newos - newSt;
              let totTime = this.convertToTime((ofms)/(1000*60));
                this.totalDaystopass = totalLeaveDays;
            this.totalMinutespass = (ofms)/(1000*60);
             let wordDay = totalLeaveDays >1?" Days ":" Day ";
               totalLeaveDays = (totalLeaveDays != 0)?totalLeaveDays+wordDay+totTime:totTime;
          } else if(this.end_day_option == 'Half' && this.end_time){
              totalLeaveDays = totalLeaveDays -1;
             let officestart = this.officeStartTime;
              let endTime = this.end_time;
              let newoe = moment(this.start_date+" "+officestart,"DD/MM/YYYY HH:mm A").valueOf();
              let newEnd = moment(this.start_date+" "+endTime,"DD/MM/YYYY HH:mm A").valueOf();
              let ofme = newEnd - newoe;
              let totTime = this.convertToTime((ofme)/(1000*60));
              this.totalDaystopass = totalLeaveDays;
              this.totalMinutespass = (ofme)/(1000*60);
               let wordDay = totalLeaveDays >1?" Days ":" Day ";
              totalLeaveDays = (totalLeaveDays != 0)?totalLeaveDays+wordDay+totTime:totTime;
          } else {
            this.totalDaystopass = totalLeaveDays;
            this.totalMinutespass = 0;
             let wordDay = totalLeaveDays >1?" Days ":" Day ";
            totalLeaveDays = totalLeaveDays+wordDay;
          }
        this.totalDays = totalLeaveDays;
      } else {
        this.totalDays = 0;
      }
    },
    getLeaveData() {
      this.$vs.loading({
        color: "primary"
      });

      let url = "user/leaves?user_id=" + this.$store.state.uInfo.id;
      this.axios
        .get(url)
        .then(response => {
          let data = response.data.data;
          this.leaves = data;
          this.pending = [];
          this.approved = [];
          this.declined = [];
          this.leaves.forEach(element => {
            if (element.status == "P") {
              this.pending.push(element);
            } else if (element.status == "A") {
              this.approved.push(element);
            } else {
              this.declined.push(element);
            }
          });
          this.$vs.loading.close();
        })
        .catch(e => {
          this.showError(e);
        });
    },
    getLeaveType() {
      this.$vs.loading({
        color: "primary"
      });

      let url = "leaveType";
      this.axios
        .get(url)
        .then(response => {
          let data = response.data.data;
          this.leavetypes = data;
          this.$vs.loading.close();
        })
        .catch(e => {
          this.showError(e);
        });
    },
    addLeave() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.button_loader(true, "#leave-addupdate");
          let input = {
            type: this.type,
            start_day_option: this.start_day_option,
            end_day_option: this.end_day_option == 'Full'?'F':'H',
            is_applied_by_other: false,
            user_id: this.$store.state.uInfo.id,
            status: "P",
            start_time: this.start_date,
            end_time: this.end_date,
            note: this.note,
            title: this.title,
            start_day_time: this.start_time ? this.start_time : "",
            end_day_time: this.end_time ? this.end_time : "",
            "totalDays":this.totalDaystopass,
            "totalMinutes" : this.totalMinutespass,
            "office" : this.$store.state.uInfo.office_id?this.$store.state.uInfo.office_id:null,
            "deapartment" : null,
          };
          this.axios
            .post("leave", input)
            .then(() => {
              this.button_loader(false, "#leave-addupdate");
              let text = "Leave added successfully!!!";
              this.$vs.notify({
                text: text,
                color: "success",
                position: "top-right"
              });
              this.cancelAdd();
              this.getLeaveData();
              this.getCalendarData();
            })
            .catch(e => {
              this.button_loader(false, "#leave-addupdate");
              this.showError(e, "#leave-addupdate");
            });
        }
      });
    },
    cancelConfirmation(id) {
      this.cancel_id = id;
      this.cancelL = true;
    },
    cancelLeave() {
      let input = {
        leave_id: this.cancel_id
      };
      this.axios
        .put("leave", input)
        .then(() => {
          this.button_loader(false, "#leavetype-addupdate");
          let text = "Leave canceled successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.cancelL = false;
          this.cancel_id = null;
          this.getLeaveData();
              this.getCalendarData();
        })
        .catch(e => {
          this.showError(e, "#leavetype-addupdate");
        });
    },
    viewNote(note) {
      this.note_view = note;
      this.ViewNote = true;
    },
     openEditEvent(event) {
      this.leavesCalendarData.forEach((element) => {
        if (element._id == event.id) {
           this.viewLeaveData.firstname = element.user_id.firstname;
          this.viewLeaveData.lastname = element.user_id.lastname;
          this.viewLeaveData.profile_image = element.user_id.profile_image;
          this.viewLeaveData.leaveType = element.type.value;
          this.viewLeaveData.note = element.note;
          this.viewLeaveData.appliedDate = moment.tz(element.createdAt, this.$store.state.uInfo.timeZone).format('DD/MM/YYYY h:mm A');
          this.viewLeaveData.leaveStartTime = moment.tz(element.start_time, this.$store.state.uInfo.timeZone).format('DD/MM/YYYY h:mm A');
          this.viewLeaveData.leaveEndTime = moment.tz(element.end_time, this.$store.state.uInfo.timeZone).format('DD/MM/YYYY h:mm A');
         
          this.viewLeaveData.leaveStatus = element.status;
        }
      });
      this.activePromptEditEvent = true;
    },
     updateMonth(val) {
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val);
    },
     usernameList(firstname, lastname) {
      let first = firstname.trim().charAt(0);
      let last = lastname.trim().charAt(0);
      let name = first.concat(last);
      return name.toUpperCase();
    },
    cancelAdd() {
      this.type = null;
      this.title = "";
      this.note = "";
      this.start_date = null;
      this.start_time = null;
      this.start_day_option = "F";
      this.end_date = null;
      this.end_time = null;
      this.totalDays = null;
      this.end_day_option = "Full";
      this.errors.clear();
      this.leaveAddEdit = false;
    },
     getCalendarData() {
      this.$vs.loading({
        color: "primary",
      });
      let url = "leave";
      this.axios
        .get(url)
        .then((response) => {
          let data = response.data.data;
          this.leavesCalendarData = data;
          this.events = [];

          data.forEach((element) => {
            this.events.push({
              id: element._id,
              title: element.user_id.firstname + " " + element.user_id.lastname,
              startDate: moment.tz(element.start_time, this.$store.state.uInfo.timeZone).format('YYYY-MM-DD h:mm A'),
              endDate: moment.tz(element.end_time, this.$store.state.uInfo.timeZone).format('YYYY-MM-DD h:mm A'),
              url: "",
              classes:
                element.status == "P"
                  ? "event-warning"
                  : element.status == "A"
                  ? "event-success"
                  : "event-danger",
              label:
                element.status == "P"
                  ? "pending"
                  : element.status == "A"
                  ? "approved"
                  : "declined",
            });
          });
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.showError(e);
        });
    },
  }
};
</script>
